/**
 * For exchange page, trip id(s) need to be present in query params
 */
export default defineNuxtRouteMiddleware((to) => {
    const localeRoute = useLocaleRoute();

    const hasQueryTripIds = !!to.query.tripUpId;

    if (!hasQueryTripIds) {
        return navigateTo(localeRoute({ name: 'esav', params: { bookingId: to.params.bookingId as string } }));
    }
});
